import React from "react";
import { Sparkles, Globe, PenTool, LayoutPanelLeft, Compass } from "lucide-react";
import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { statement } from "../mock";

const iconMap = { Sparkles, Globe, PenTool, LayoutPanelLeft, Compass };

const Statement = () => {
  return (
    <section id="about" className="bg-[#ececec] py-24 md:py-36 px-5">
      <div className="max-w-[900px] mx-auto text-center">
        <Reveal>
          <span className="font-script text-[#ff4d17] text-3xl md:text-4xl">{statement.eyebrow}</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-cal mt-6 text-[30px] sm:text-[44px] md:text-[54px] leading-[1.1] text-[#141414]">
            {statement.parts.map((p, i) => (
              <span key={i} className={p.muted ? "text-[#a3a3a3]" : ""}>
                {p.text}
              </span>
            ))}
          </h2>
        </Reveal>

        <div className="mt-12 flex flex-wrap justify-center gap-3 max-w-[560px] mx-auto">
          {statement.tags.map((t, i) => {
            const Icon = iconMap[t.icon];
            return (
              <motion.div
                key={t.label}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="flex items-center gap-2 bg-[#3a3a3a] text-white px-5 py-2.5 rounded-full text-[15px] hover:bg-[#ff4d17] transition-colors cursor-default"
              >
                <Icon size={16} />
                {t.label}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Statement;
